// @ts-nocheck




import { createAction, createSlice } from '@reduxjs/toolkit';


import { contractVehicleOrderApi } from './../lib/api';
import type { ContractVehicleOrder } from './../lib/types';

export const SET_CONTRACT_VEHICLE_ORDER = 'vehicles/contractVehicleOrder/set';
export const CLEAN_CONTRACT_VEHICLE_ORDER =
'vehicles/contractVehicleOrder/clean';



const initialState: ContractVehicleOrder | null = null;

const setContractVehicleOrderAction = createAction<ContractVehicleOrder>(SET_CONTRACT_VEHICLE_ORDER);
const cleanContractVehicleOrderAction = createAction(CLEAN_CONTRACT_VEHICLE_ORDER);

const contractVehicleOrderSlice = createSlice({
  name: 'contractVehicleOrder',
  initialState: initialState as ContractVehicleOrder | null,
  reducers: {},
  extraReducers: (builder) => {
    builder.
    addCase(setContractVehicleOrderAction, (state, { payload }) => ({ ...payload })).
    addCase(cleanContractVehicleOrderAction, () => initialState);
  }
});

export const contractVehicleOrderActions = {
  set: setContractVehicleOrderAction,
  clean: cleanContractVehicleOrderAction
};

export const addContractVehicleOrder = (
contractVehicleOrder) =>
async (dispatch) => {
  await contractVehicleOrderApi.addContractVehicleOrder(contractVehicleOrder);
};

export const updateContractVehicleOrder = (
contractVehicleOrder,
getState) =>
async (
dispatch,
getState) =>
{
  const updatedContractVehicleOrder = await contractVehicleOrderApi.updateContractVehicleOrder(
    contractVehicleOrder
  );
  dispatch(contractVehicleOrderActions.set({ ...updatedContractVehicleOrder }));
};

export const deleteContractVehicleOrder = (
id) =>
async (dispatch) =>
await contractVehicleOrderApi.deleteContractVehicleOrder(id);

export const fetchContractVehicleOrder = (id) => async (
dispatch) =>
{
  const contractVehicleOrder = await contractVehicleOrderApi.fetchContractVehicleOrder(
    id
  );
  dispatch(contractVehicleOrderActions.set({ ...contractVehicleOrder }));
};

export const cleanContractVehicleOrder = () => (dispatch) =>
dispatch(contractVehicleOrderActions.clean());

export default contractVehicleOrderSlice.reducer;
